import cn from "classnames"
import React from "react"

import styles from "./index.module.css"

type LeadProps = {
  children?: any
  as?: any
  className?: string
  inHeadingList?: boolean
}

export const Lead: React.FC<LeadProps> = ({ children, as, className, inHeadingList, ...props }) => {
  const Component = as || "div"

  return (
    <Component
      className={cn(styles.Lead, className, { [styles.InHeadingList]: inHeadingList })}
      dangerouslySetInnerHTML={{ __html: children }}
      {...props}
    />
  )
}
